<template>
  <v-card flat class="rounded-xl overflow-hidden pa-8">
    <custom-tabs v-model="tabs" :tab-items="tabItems" grow>
      <template v-slot:staticItems>
        <v-tabs-items v-model="tabs">
          <!-- تب اول: کسر قیمت رقبا -->
          <v-tab-item>
            <competitor-deduction-tab />
          </v-tab-item>
          <!-- تب دوم: هزینه بسته‌بندی -->
          <v-tab-item>
            <packaging-cost-tab />
          </v-tab-item>
          <!-- تب سوم: تخفیف فروش عمده -->
          <v-tab-item>
            <Bulk-discount-tab />
          </v-tab-item>
          <!-- تب چهارم: فروشگاه‌های آنلاین -->
          <v-tab-item>
          </v-tab-item>
        </v-tabs-items>
      </template>
    </custom-tabs>
  </v-card>
</template>

<script>
import CompetitorDeductionTab from "./CompetitorDeductionTab.vue";
import PackagingCostTab from "./PackagingCostTab.vue";
import OnlineStoresTab from "./OnlineStoresTab.vue";
import BulkDiscountTab from "./BulkDiscountTab.vue";

export default {
  name: "general_settings",
  components: {
    CompetitorDeductionTab,
    PackagingCostTab,
    OnlineStoresTab,
    BulkDiscountTab
  },
  data: () => ({
    tabs: 0,
    tabItems: [
      { text: "کسر قیمت رقبا", value: 0, icon: "cash-minus" },
      { text: "هزینه بسته‌بندی", value: 1, icon: "package-variant" },
      { text: "تخفیف فروش عمده", value: 2, icon: "cart-percent" },
    ]
  })
};
</script>
